import { render, staticRenderFns } from "./ShareholderInd.vue?vue&type=template&id=781842ae&"
import script from "./ShareholderInd.vue?vue&type=script&lang=js&"
export * from "./ShareholderInd.vue?vue&type=script&lang=js&"
import style0 from "./ShareholderInd.vue?vue&type=style&index=0&id=781842ae&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports